// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__u6Z5A","label":"Radio_label__2wXBw","checkMark":"Radio_checkMark__2q0lT","disabled":"Radio_disabled__2MeO8"};